import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { appRoutes } from "./app-routes";
import GeneralDataProtectionRegulationAcceptancePopup from "./components/general-data-protection-regulation-acceptance-popup/GeneralDataProtectionRegulationAcceptancePopup";
import ProcessingOfEmailAddressAcceptancePopup from "./components/processing-of-email-address-acceptance-popup/ProcessingOfEmailAddressAcceptancePopup";
import TermsOfUseAcceptancePopup from "./components/terms-of-use-acceptance-popup/TermsOfUseAcceptancePopup";
import { useAuth } from "./contexts/auth";
import { SideNavOuterToolbar as SideNavBarLayout } from "./layouts";
import { RoleEnum } from "./types";

export const Content = () => {
  const { user } = useAuth();
  const location = useLocation();

  const isEmployee = user?.roles?.includes(RoleEnum.Pracownik) ?? false;
  const isForeman = user?.roles?.includes(RoleEnum.Majster) ?? false;
  const isManager = user?.roles?.includes(RoleEnum.Kierownik) ?? false;
  const isSupervisor = user?.roles?.includes(RoleEnum.Manager) ?? false;
  const isCompanyStaff = user?.roles?.includes(RoleEnum.KadrySpolki) ?? false;
  const isCompanyAdministrator =
    user?.roles?.includes(RoleEnum.AdministratorSpolki) ?? false;
  const isHeadAdministrator =
    user?.roles?.includes(RoleEnum.AdministratorGlowny) ?? false;
  const isTemporaryManager = user?.isTimeManager;

  // Popupy z akceptacją regulaminów
  if (!user?.generalDataProtectionRegulationAccepted) {
    return <GeneralDataProtectionRegulationAcceptancePopup />;
  }

  if (!user?.termsOfUseAccepted) {
    return <TermsOfUseAcceptancePopup />;
  }

  if (!user?.processingOfEmailAddressAccepted) {
    return <ProcessingOfEmailAddressAcceptancePopup />;
  }

  if (location.pathname === "/employees") {
    if (!isCompanyAdministrator && !isHeadAdministrator) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/availability") {
    if (isEmployee && user?.contractType !== 1) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/schedule") {
    if (!isManager) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/presence") {
    if (
      !isEmployee &&
      !isForeman &&
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff &&
      !isCompanyAdministrator &&
      !isHeadAdministrator &&
      !isTemporaryManager
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/hourly-summary") {
    if (
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff &&
      !isCompanyAdministrator &&
      !isHeadAdministrator &&
      !isTemporaryManager
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/projects") {
    // if (
    //   !isManager &&
    //   !isSupervisor &&
    //   !isCompanyStaff &&
    //   !isCompanyAdministrator &&
    //   !isHeadAdministrator &&
    //   !isTemporaryManager
    // ) {
    //   return <Navigate to="/access-denied" />;
    // }

    if (!isSupervisor && !isCompanyAdministrator && !isHeadAdministrator) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/transfer-of-employees") {
    if (
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff &&
      !isCompanyAdministrator &&
      !isHeadAdministrator &&
      !isTemporaryManager
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/awards") {
    if (
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff &&
      !isCompanyAdministrator &&
      !isHeadAdministrator &&
      !isTemporaryManager
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/sheets") {
    if (
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff &&
      !isCompanyAdministrator &&
      !isHeadAdministrator &&
      !isTemporaryManager
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/evalutation-summary") {
    if (
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff &&
      !isCompanyAdministrator &&
      !isHeadAdministrator &&
      !isTemporaryManager
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/reading-notes") {
    if (!isHeadAdministrator) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/admin-panel") {
    if (!isCompanyAdministrator && !isHeadAdministrator) {
      return <Navigate to="/access-denied" />;
    }
  }

  if (location.pathname === "/documents") {
    if (
      !isEmployee &&
      !isForeman &&
      !isManager &&
      !isSupervisor &&
      !isCompanyStaff
    ) {
      return <Navigate to="/access-denied" />;
    }
  }

  return (
    <SideNavBarLayout>
      <Routes>
        {appRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </SideNavBarLayout>
  );
};
